import { z } from 'zod';

export const ModerationTermsDTO = z.string();

export type ModerationTermsDTO = z.infer<typeof ModerationTermsDTO>;
